import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import getAxiosInstance from '../../Utils/axios'

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default function AddMedia() {
    const [isLoading, setIsLoading] = useState(false);
    let { mediaID } = useParams()

    const [Title, setTitle] = useState("")
    const [Type, setType] = useState("text")
    const [Text, setText] = useState("")
    const [MediaFiles, setMediaFiles] = useState(null)
    const [Repeat, setRepeat] = useState(false)
    const [AutoPlay, setAutoPlay] = useState(false)
    const [ImagesHoldTime, setImagesHoldTime] = useState([])

    const reset = () => {
        setType('text')
        setText("")
        setMediaFiles(null)
    }

    const handleHoldTimeChange = (index, value) => {
        // Only allow numbers and validate range
        if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 1 && parseInt(value) <= 999)) {
            const newHoldTimes = [...ImagesHoldTime]
            newHoldTimes[index] = value === '' ? '' : parseInt(value)
            setImagesHoldTime(newHoldTimes)
        }
    }

    const saveMedia = () => {
        if(Title.trim() === "") return Toast.fire({ icon: 'error', title: 'Media title required' })
        if((!MediaFiles || MediaFiles.length === 0) && Text.trim() === "") return Toast.fire({ icon: 'error', title: 'Add required media' })
        
        // Validate hold times for multiple images
        if(Type === "photo" && MediaFiles && MediaFiles.length > 1) {
            const hasEmptyOrInvalid = ImagesHoldTime.some(time => time === '' || time < 1 || time > 999)
            if(hasEmptyOrInvalid) return Toast.fire({ icon: 'error', title: 'Please enter valid hold time (1-999 seconds) for all images' })
        }
        
        setIsLoading(true);
        let link = "/admin/add-media"
        let formData = new FormData();
        formData.append('title', Title);
        formData.append('text', Text);
        formData.append('type', Type);
        formData.append('repeat', Repeat);
        formData.append('auto_play', AutoPlay);
        
        // Add images hold time only if multiple images
        if(Type === "photo" && MediaFiles && MediaFiles.length > 1) {
            formData.append('imagesHoldTime', JSON.stringify(ImagesHoldTime));
        }
        
        if(MediaFiles?.length > 0) {
            for (const key of MediaFiles) {
                formData.append('upload', key)
            }
        }

        if(mediaID) {
            formData.append('id', mediaID);
            link = "/admin/update-media"
        }

        getAxiosInstance()
            .post(link, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then((res) => {
                // Validating form
                setIsLoading(false);
                // console.log(res.data)
                if(res.data.status === 'success'){
                    Toast.fire({ icon: 'success', title: `Media ${mediaID?"updated":"added"} successfully.` })
                    window.location.href = '/broadcasting/media'
                } else if (res.data.status === "error") Toast.fire({ icon: 'error', title: res.data.message })
                else Toast.fire({ icon: 'error', title: 'Cannot Process Request' })
            })
            .catch((err) => {
                setIsLoading(false);
                if(err.response.status === 401) Toast.fire({ icon: 'error', title: 'Unauthorized Access' })
                console.log(err);
            });
    }

    useEffect(() => {
        if(mediaID) {
            let params = { id: mediaID }
    
            const data = Object.keys(params)
                .map((key) => `${key}=${encodeURIComponent(params[key])}`)
                .join('&');
    
            getAxiosInstance()
                .post("/admin/media", data,{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                .then((res) => {
                    if(res.data.status === 'success'){
                        // console.log(res.data)
                        let result = res.data.result
                        setText(result.first_name)
                        setMediaFiles(result.last_name)
                    } else if (res.data.status === "error") console.log(res.data.message)
                    else console.log('Cannot Process Request')
                })
                .catch((err) => console.log(err));
        }
    }, [mediaID])

    const clearData = () => {
        setMediaFiles(null)
        setText("")
        setRepeat(false)
        setAutoPlay(false)
        setImagesHoldTime([])
    }

    // Initialize hold times when media files change
    useEffect(() => {
        if (Type === "photo" && MediaFiles && MediaFiles.length > 1) {
            // Set default 5 seconds for each image
            setImagesHoldTime(MediaFiles.map(() => 5))
        } else {
            setImagesHoldTime([])
        }
    }, [MediaFiles, Type])

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h1 className="m-0 text-bold">{mediaID?"Edit":"Add"} Media</h1>
                                        <div className="row mt-3">
                                            <div className="col-md-8">
                                                <div className="card card-dark card-outline card-tabs">
                                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                                        <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                                            <li className="nav-item" onClick={(e) => {
                                                                setType('text')
                                                                clearData()
                                                            }} style={{ cursor: 'pointer' }}>
                                                                <a className={`nav-link ${Type === "text"?"active":""}`}>
                                                                    <i className="fas fa-text" /> Text
                                                                </a>
                                                            </li>
                                                            <li className="nav-item" onClick={(e) => {
                                                                setType('photo')
                                                                clearData()
                                                            }} style={{ cursor: 'pointer' }}>
                                                                <a className={`nav-link ${Type === "photo"?"active":""}`}>
                                                                    <i className="fas fa-image" /> Photo
                                                                </a>
                                                            </li>
                                                            <li className="nav-item" onClick={(e) => {
                                                                setType('video')
                                                                clearData()
                                                            }} style={{ cursor: 'pointer' }}>
                                                                <a className={`nav-link ${Type === "video"?"active":""}`}>
                                                                    <i className="fas fa-video" /> Video
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="tab-content" id="custom-tabs-three-tabContent">
                                                            <input type="text" className="form-control mb-3" id="mediaTitle" value={Title} onChange={(e) => setTitle(e.target.value)} placeholder="Media Title" />
                                                            {Type === "text" && <div className="tab-pane show active">
                                                                <textarea className="form-control" rows={3} placeholder="Write Your Text" value={Text} onChange={(e) => setText(e.target.value)} />
                                                            </div>}
                                                            {Type === "photo" && <div className="tab-pane show active">
                                                                <div className="custom-file">
                                                                    <input type="file" className="custom-file-input" id="customMediaFiles" accept="image/*" multiple onChange={(e) => setMediaFiles([...e.currentTarget.files])} />
                                                                    <label className="custom-file-label" htmlFor="customMediaFiles">Choose Image</label>
                                                                </div>
                                                                {MediaFiles && MediaFiles.length > 1 && (
                                                                    <div className="alert alert-info mt-3">
                                                                        <i className="fas fa-info-circle"></i> Set display duration (in seconds) for each image. Default is 5 seconds.
                                                                    </div>
                                                                )}
                                                                <div className="row mt-3">
                                                                    {MediaFiles?.map((photo, index) => (
                                                                        <div className="col-md-6" key={photo.name}>
                                                                            <div className="card mb-2 bg-gradient-dark">
                                                                                <img className="card-img-top" src={URL.createObjectURL(photo)} alt="Selected Image" />
                                                                                <div className="card-img-overlay d-flex flex-column justify-content-end">
                                                                                    <button type="button" className="btn btn-outline-danger btn-block" onClick={(e) => {
                                                                                        setMediaFiles((oldFiles) => {
                                                                                            const newFiles = oldFiles.filter(file => file.name !== photo.name)
                                                                                            return newFiles
                                                                                        })
                                                                                        setImagesHoldTime((oldTimes) => {
                                                                                            const newTimes = [...oldTimes]
                                                                                            newTimes.splice(index, 1)
                                                                                            return newTimes
                                                                                        })
                                                                                    }}>Remove</button>
                                                                                </div>
                                                                            </div>
                                                                            {MediaFiles.length > 1 && (
                                                                                <div className="form-group">
                                                                                    <label htmlFor={`holdTime${index}`} className="text-bold">
                                                                                        Image {index + 1} Display Time (seconds)
                                                                                    </label>
                                                                                    <input 
                                                                                        type="text" 
                                                                                        className="form-control" 
                                                                                        id={`holdTime${index}`}
                                                                                        value={ImagesHoldTime[index] || ''}
                                                                                        onChange={(e) => handleHoldTimeChange(index, e.target.value)}
                                                                                        placeholder="Enter seconds (1-999)"
                                                                                        maxLength="3"
                                                                                    />
                                                                                    <small className="form-text text-muted">
                                                                                        Enter a value between 1 and 999 seconds
                                                                                    </small>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>}
                                                            {Type === "video" && <div className="tab-pane show active">
                                                                <div className="custom-file">
                                                                    <input type="file" className="custom-file-input" id="customMediaFiles" accept="video/*" onChange={(e) => setMediaFiles([...e.currentTarget.files])} />
                                                                    <label className="custom-file-label" htmlFor="customMediaFiles">{MediaFiles?.length > 0?MediaFiles[0].name:"Choose Video"}</label>
                                                                </div>
                                                            </div>}
                                                            {(Type === "photo" || Type === "video") && <div className="custom-control custom-checkbox mt-3">
                                                                <input className="custom-control-input custom-control-input-dark" type="checkbox" id="repear" checked={Repeat} onChange={(e) => setRepeat(!Repeat)}/>
                                                                <label htmlFor="repear" className="custom-control-label" style={{ fontWeight: 'normal' }}>Repeat Media</label>
                                                            </div>}
                                                            {Type === "video" && <div className="custom-control custom-checkbox mt-3">
                                                                <input className="custom-control-input custom-control-input-dark" type="checkbox" id="autoPlay" checked={AutoPlay} onChange={(e) => setAutoPlay(!AutoPlay)}/>
                                                                <label htmlFor="autoPlay" className="custom-control-label" style={{ fontWeight: 'normal' }}>AutoPlay Video</label>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-8">
                                                <button type="button" className="btn btn-dark float-right" onClick={(e) => saveMedia()} disabled={isLoading}>{mediaID?"Save":"Add"} Media</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
